import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BeautybookComponent } from './beautybook.component';
import { BeautybookRoutingModule } from './beautybook-routing.module';
import { SharedModule } from 'primeng/api';
import { FcDrawerModule } from '@shared/components/fc-drawer/fc-drawer.module';
import { SwiperModule } from 'swiper/angular';
import { BeautybookItemComponent } from './components/beautybook-item/beautybook-item.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BeautybookAddComponent } from './pages/beautybook-add/beautybook-add.component';
import { BeautybookDetailComponent } from './pages/beautybook-detail/beautybook-detail.component';
import { SelfieSelectDialogComponent } from './components/selfie-select-dialog/selfie-select-dialog.component';
import { SelfieUploadDialogComponent } from './components/selfie-upload-dialog/selfie-upload-dialog.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { BeautybookListComponent } from './pages/beautybook-list/beautybook-list.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SkeletonModule } from 'primeng/skeleton';

@NgModule({
  declarations: [
    BeautybookComponent,
    BeautybookItemComponent,
    BeautybookAddComponent,
    BeautybookDetailComponent,
    SelfieSelectDialogComponent,
    SelfieUploadDialogComponent,
    BeautybookDetailComponent,
    BeautybookListComponent,
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    BeautybookRoutingModule,
    SharedModule,
    FcDrawerModule,
    SwiperModule,
    FontAwesomeModule,
    ImageCropperModule,
    SkeletonModule,
  ],
  exports: [BeautybookItemComponent],
})
export class BeautybookModule {}
